import { FileReader, FileWriter } from '@/platform'
import EventBase from './EventClass/EventBase'
import { createEventFromReader, ensureEventListInstances } from './EventClass/eventFromReader'
import ModuleId from './DataStructModuleId'
import { normalizeString } from './gameBinUtils'

type LazyReaderFactory = () => Promise<FileReader | null>

class MapInfo{
	public canSave: boolean = false
	public mid: number = ModuleId.mapInfo
	/**
	 * 场景的名称
	 */
	public Name: string = ''
	/**
	 * 地图ID
	 */
	public Id: number = 0
	/**
	 * 母地图的ID
	 */
	public ParentId: number = -1
	/**
	 * 内部使用地图的序列
	 */
	public Order: number = 0
	/**
	 * 该剧情段的Evet集合 List 一般放在最后
	 */
	public List: Array<EventBase> = new Array()
	/** 首次打开工程时仅记录事件数量，避免一次性实例化全部 EventBase。 */
	public eventCount: number = 0
	/**
	 * 是否为高级模式（false=初级，true=高级）
	 */
	public IsHard: boolean = true

	public Childs: Array<MapInfo> = new Array()

	constructor(
		param?:
			| {
				name: string
				id: number
				parentId: number
				order: number
				list: EventBase[]
			} | FileReader

	) {
		if (param && 'name' in param) {
			const { name, id, parentId, order, list } = param
			this.Name = name
			this.Id = id
			this.ParentId = parentId
			this.Order = order
			this.List = ensureEventListInstances(list ?? [])
		} else if (param instanceof FileReader) {
			this.readBin(param as FileReader, 0)
		} else {
			this.Name = '剧情1'
			this.Id = 1
			this.ParentId = 0
			this.Order = 0
			this.List = new Array()
		}
	}

	readBin(reader: FileReader, select:number): void {	
		this.Name = reader.readString()
		this.Id = reader.readInt()
		this.ParentId = reader.readInt()
		this.Order = reader.readInt()
		/** 与 cg_v3 MapInfo.writeBin 一致：IsHard 在 List 长度之前 */
		this.IsHard = reader.readBool()
		this.IsHard = true
		this.List = new Array()
		const length = reader.readInt()
		this.eventCount = length
		this.List.length = length
		for (let i = 0; i < length; i++) {
			this.List[i] = createEventFromReader(reader)
		}
	}

	writeBin(writer: FileWriter): void {	
		writer.writeString(this.Name)
		writer.writeInt(this.Id)
		writer.writeInt(this.ParentId)
		writer.writeInt(this.Order)
		writer.writeBool(true)
		const count = this.List.length
		writer.writeInt(count)
		for (let i = 0; i < this.List.length; i++) {
			this.List[i]?.writeBin(writer)
		}
	}

	writeGameBin(writer: FileWriter): void {
		writer.writerIntLength()
		writer.writeString(normalizeString(this.Name))
		writer.writeInt(this.Id)
		writer.writeInt(this.List.length)
		for (let i = 0; i < this.List.length; i++) {
			this.List[i]?.writeGameBin(writer)
		}
		writer.writerLength()
	}
}
export default MapInfo
